import { useContext } from 'react';

import { TransContext } from '../contexts/TransContext';

function useTrans() {
  return useContext(TransContext);
}

export default useTrans;
